const e = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M0%2040H40V0H0V40Z'%20fill='%23F68E1E'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M27.5917%2020.4743L19.3716%208.45117H12.4204L20.5985%2020.4743L12.4204%2032.4383H19.3716L27.5917%2020.4743Z'%20fill='%23FEFEFE'/%3e%3c/svg%3e";
export {
  e as default
};
